module.exports = __webpack_public_path__ + "img/Portafolio Kontakt_5.206ecd97.png";